import React, { useState } from 'react';
import ConfirmationModal from '../../ConfirmationModal';
import AdminListActionsDropdown from '../AdminListActionsDropdown';
import EmailTemplateListActionsDropdown from './EmailTemplateListActionsDropdown';
import { useMediaQuery } from 'react-responsive';


const ToTheUserTableRow = ({ emailTemplate, handleChangeStatus, handleDeleteUser, type }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);


  const handleShowDeactivateModal = () => setShowDeactivateModal(true);
  const handleCloseDeactivateModal = () => setShowDeactivateModal(false);



  const confirmDeactiavateUser = () => {
    handleChangeStatus(emailTemplate, emailTemplate.active)
    handleCloseDeactivateModal();
  };

  const confirmDeleteUser = () => {
    handleDeleteUser(emailTemplate.id);
    handleCloseDeleteModal();
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <>
     {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div style={{float:'right'}}>
                <EmailTemplateListActionsDropdown type={type} emailTemplate={emailTemplate} handleShowDeactivateModal={handleShowDeactivateModal} handleShowDeleteModal={handleShowDeleteModal} />
                </div>
                 {/* <button className="btn btn-primary">View Details</button>
                 <button className="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal">
                   Deactivate
                 </button>
                 <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteuser">
                   Delete
                 </button> */}
               </div>


                 <h5><strong>Title: </strong>{emailTemplate.title}</h5>
                 <p><strong>Subject: </strong>{emailTemplate.subject || "-"}</p>
               </div>
                
               <div className=  {"card-body "} >
                 
                 <p><strong>From: </strong> {emailTemplate.from || "-"}</p>
                 <p><strong>BCC: </strong>  {(() => {
            try {
              const bccArray = JSON.parse(emailTemplate.bcc); // Parse the stringified array
              return Array.isArray(bccArray) && bccArray.length > 0
                ? bccArray.join(", ")
                : "-";
            } catch (error) {
              return "-"; // Fallback if JSON parsing fails
            }
          })()}</p> 

                 <p>
                   <strong>Status:</strong>{" "}
                   <span className={emailTemplate.active ? "badge bg-success" : "badge bg-danger"}>
                     {emailTemplate.active ? "Active" : "Inactive"}
                   </span>
                 </p>
               </div>
          
             </div>
           
         </div>
         ):(<>
      <tr>
        <td>{emailTemplate.title}</td>
        {/* <td>{emailTemplate.is_superemailTemplate ? "super-emailTemplate" : "emailTemplate"}</td> */}
        {/* <td>{emailTemplate.id}</td> */}
        <td>{emailTemplate.subject || "-"}</td>
        <td>{emailTemplate.from || "-"}</td>
        {/* <td>{emailTemplate.bcc || "-"}</td> */}
        <td>
          {(() => {
            try {
              const bccArray = JSON.parse(emailTemplate.bcc); // Parse the stringified array
              return Array.isArray(bccArray) && bccArray.length > 0
                ? bccArray.join(", ")
                : "-";
            } catch (error) {
              return "-"; // Fallback if JSON parsing fails
            }
          })()}
        </td>


        {/* <td>{emailTemplate.phone_number}</td> */}
        <td>
          <div className={emailTemplate.active ? "el-active" : "el-inactive"}>
            <div className={emailTemplate.active ? "el-activebtn" : "el-inactive"}></div>
            {emailTemplate.active ? "Active" : "Inactive"}
          </div>
        </td>
        <td>
          <EmailTemplateListActionsDropdown type={type} emailTemplate={emailTemplate} handleShowDeactivateModal={handleShowDeactivateModal} handleShowDeleteModal={handleShowDeleteModal} />
        </td>
      </tr>
</>
         )}
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={confirmDeleteUser}
        title="Confirm Delete"
        body="Are you sure you want to delete this email template?"
      />

      {/* Deactiavate Confirmation Modal */}
      < ConfirmationModal
        show={showDeactivateModal}
        onHide={handleCloseDeactivateModal}
        onConfirm={confirmDeactiavateUser}
        title=""
        body={`Are you sure you want to ${emailTemplate.active ? 'deactivate' : 'activate'} email template?`}
        type='deactivateactivate'
      />

      {/* <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this user?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDeleteUser}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default ToTheUserTableRow;
